import React, { useState } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import { useNavigate } from "react-router-dom";
import Trash from '../icons/tarsh';

function DeleteButton({ index,postId, commentId, callback , username, refetch, setIsRefActive, onDelete}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const navigate = useNavigate();
  const mutation = commentId ? DELETE_CONTEXTO_MUTATION : DELETE_TRAINED_MUTATION;

  const [deletePostOrMutation, { loading, error }] = useMutation(mutation, {
    onError: (error) => {
      console.error('Mutation error:', error.message);
      // Handle error display or logging here
    },
    update(proxy) {
      setConfirmOpen(false);
      if (!commentId) {
        const data = { ...proxy.readQuery({ query: FETCH_POSTS_QUERY_USER_TAINED, variables: {username:username} }) };
        data.getPosts = data.getPosts.filter((p) => p.id !== postId);
        proxy.writeQuery({ query: FETCH_POSTS_QUERY_USER_TAINED, data });
      }
      if (callback) callback();
    },
    variables: {
      postId,
      commentId,
      username
    }
    
  });

  const handleConfirm = () => {
    deletePostOrMutation()
      .then(() => {

        if(!commentId){
            navigate(`/trained`, { state: { refetchNeeded: true } });
        }
      
        refetch();
        ///setIsRefActive(true)
      })
      .catch((error) => {
        console.error('Mutation execution error:', error.message);
        // Handle error display or logging here
      });
      
    
  };


// Define la función que maneja ambas acciones
const handleDeleteClick = () => {
   //// setIsRefActive(false)
    setConfirmOpen(true);

  };

  return (
    <>
      <span
        style={{ cursor: 'pointer', color: '#333', padding: '15px 15px' }}
        ///onClick={() => setConfirmOpen(true); onDeleteClick();}
        onClick={handleDeleteClick}
      >
        <Trash/> {/* Icono X para eliminar */}
     
  
      </span>
      
      {confirmOpen && (
        <div style={{ marginTop: 10 }}>
          <p>¿Estás seguro de que quieres eliminar este chat?</p>
          <button onClick={() => setConfirmOpen(false)}>Cancelar</button>
          <button onClick={handleConfirm} disabled={loading}>Confirmar</button>
          {error && <p style={{ color: 'red' }}>Error al eliminar.</p>}
        </div>
      )}
    </>
  );
}

const DELETE_TRAINED_MUTATION = gql`
  mutation deletePostTrain($postId: ID!) {
    deletePostTrain(postId: $postId)
  }
`;

const DELETE_CONTEXTO_MUTATION = gql`
  mutation deleteContextTrained($postId: ID!, $commentId: ID!, $username: String!) {
    deleteContextTrained(postId: $postId, commentId: $commentId, username: $username) {
        id
        contexto{
          user
          assistant
        }
    }
  }
`;

const FETCH_POSTS_QUERY_USER_TAINED = gql`
  query getPostsTrainByUsername($username: String!) {
    getPostsTrainByUsername(username: $username) {
      id
      titulo
      cuerpo
      resumen
      tacs
      createdAt
      username
    }
  }
`;



export default DeleteButton;


